<template>
    <div class="counter">
        <input type="number" inputmode="numeric" :min="props.min" pattern="[0-9]*" placeholder="0"  data-link="#form-133" readonly v-model="currentValue" @change="onChange">
        <button type="button"  style="visibility: hidden">
            X
        </button>
        <button type="button" role="button" id="" class="more" @click="remove">
            x <span class="screen-reader">{{ copydeck.accessibility.btn_decrease[lang] }}</span>
        </button>
    </div>
</template>

<script>
export default {
    name: "OrderRemoval"
}
</script>

<script setup>

import { ref , computed } from "vue";
import {useMainStore} from "../stores/main";
import {storeToRefs}  from "pinia";

let store = useMainStore();
let { copydeck, lang } = storeToRefs(store);

const props = defineProps(["value","max", "min", "product", "groupIndex"]);
const emits = defineEmits(["change"]);


const currentValue = computed ( () =>  getCurrentValue(props.value));

function getCurrentValue (value)
{
    return parseInt(value);
}

function remove ()
{
    currentValue.value = 0;
    emits("change", props.product.id, {quantity: 0, groupIndex: props.groupIndex});

}



</script>
